import { makeStyles, Theme } from '@material-ui/core';

export const useLayoutFormHeaderContainerStyles = makeStyles((theme: Theme) => ({
    headerContainer: {
        margin: '32px 0px 24px;',
        position: 'relative',
    },
    logoImage: {
        width: '170px',
    },
    plusImage: {
        width: '84px',
        position: 'absolute',
        right: '-30px',
    },
}));
